import { Platform } from 'react-native';
import get from 'lodash/get';
export function isMobile() {
  try {
    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}
export function isAndroid() {
  try {
    const android = navigator.userAgent.match(/Android/i);
    return android;
  } catch (e) {
    return false;
  }
}
export function isIphone() {
  try {
    const iphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
    return iphone;
  } catch (e) {
    return false;
  }
}

/**
 * Parameter 'routeQueries' just needed for server-side validation
 * If you just need validation WebView for client-side, you don't have to pass it
 * Why 'routeQueries' is not required?
 *   a1. Cleaner code for client-side validation, just call 'isWebView()'
 *   a2. Backward compatibility for native app
 */
export function isWebView(routeQueries = {}) {
  if (routeQueries.wv === 'true') return true;
  const userAgent = get(global, 'window.navigator.userAgent', '');
  const isAndroidWebView = /; wv/i.test(userAgent);
  const isIosWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  return isAndroidWebView || isIosWebView;
}
export function isSketchUp() {
  try {
    const sketchUp = navigator.userAgent.match(/SketchUp/i);
    return sketchUp;
  } catch (e) {
    return false;
  }
}
export function getPlatform() {
  const platform = Platform.OS;
  if (platform === 'web') {
    if (isWebView()) {
      return isAndroid() ? 'android' : 'ios';
    }
    return isMobile() ? 'mobile-web' : 'desktop-web';
  }
  return platform;
}